export default __webpack_public_path__ + "static/media/DinosaursFossilHunters_01.c8592ec5.png";